import styled from "styled-components";

export const EmptyStateWrapperDiv = styled.div`
  height: calc(100vh - 120px);
  display: flex;
  align-items: flex-start;
  justify-content: center;
  background: #fff;
  padding: 48px 24px 24px;
`;

export const EmptyStateCardDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  width: min(560px, 100%);
  max-width: 560px;
  padding: 48px 56px;
  border-radius: 8px;
  border: 1px solid var(--Pearl, #ecf1f4);
  background: #fff;
  box-shadow: 0 8px 24px 0 rgba(0, 0, 0, 0.08);
  text-align: center;

  .shopifyBrandLogo {
    width: 96px;
    height: 96px;
    object-fit: contain;
  }

  img {
    width: 96px;
    height: 96px;
    object-fit: contain;
  }

  .emptyHeading {
    color: var(--Dark-Grey, #262641);
    font-size: 22px;
    font-weight: 600;
    line-height: 150%;
  }

  .emptyDescription {
    color: var(--Light-Grey, #8c8ca1);
    font-size: 14px;
    font-weight: 400;
    line-height: 160%;
    max-width: 420px;
  }
`;

export const ConnectPageWrapperDiv = styled.div`
  min-height: calc(100vh - 120px);
  display: flex;
  align-items: flex-start;
  justify-content: center;
  background: #fff;
  padding: 48px 24px 24px;
`;

export const ConnectPageCardDiv = styled.div`
  width: 520px;
  border-radius: 4px;
  border: 1px solid var(--Pearl, #ecf1f4);
  background: #fff;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.08);
  padding: 32px;

  .heading {
    color: var(--Dark-Grey, #262641);
    font-size: 20px;
    font-weight: 600;
    line-height: 150%;
    margin-bottom: 8px;
  }

  .description {
    color: var(--Light-Grey, #8c8ca1);
    font-size: 14px;
    line-height: 150%;
    margin-bottom: 18px;
  }

  .label {
    color: var(--Dark-Grey, #262641);
    font-size: 13px;
    font-weight: 500;
    margin-bottom: 8px;
  }

  .shopifyLogo {
    width: 64px;
    height: 64px;
    object-fit: contain;
    margin-bottom: 12px;
  }

  input {
    width: 100%;
    border: 1px solid #dadff3;
    border-radius: 4px;
    height: 38px;
    padding: 8px 12px;
    margin-bottom: 16px;
    outline: none;
  }
`;

/** Full-bleed shell for Shopify self-signup (public install path). */
export const SignupShellDiv = styled.div`
  --signup-ink: #262641;
  --signup-muted: #8c8ca1;
  --signup-line: #ecf1f4;
  --signup-field: #dadff3;
  --signup-accent: #1249bf;
  --signup-accent-soft: #e8effc;

  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  background:
    radial-gradient(1200px 480px at 10% -10%, var(--signup-accent-soft) 0%, transparent 55%),
    radial-gradient(900px 420px at 100% 0%, #f3f7fb 0%, transparent 50%),
    linear-gradient(180deg, #f7f9fc 0%, #eef2f7 100%);
`;

export const SignupPanelDiv = styled.div`
  width: min(560px, 100%);
  border-radius: 12px;
  border: 1px solid var(--signup-line);
  background: #fff;
  box-shadow: 0 18px 48px rgba(16, 36, 77, 0.1);
  padding: 36px 40px 32px;

  @media (max-width: 560px) {
    padding: 28px 20px 24px;
    border-radius: 10px;
  }
`;

export const SignupBrandRowDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 22px;

  .brandMark {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .brandMark img {
    width: 40px;
    height: 40px;
    object-fit: contain;
  }

  .brandText {
    display: flex;
    flex-direction: column;
    gap: 2px;
  }

  .brandEyebrow {
    color: var(--signup-muted);
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.06em;
    text-transform: uppercase;
  }

  .brandTitle {
    color: var(--signup-ink);
    font-size: 15px;
    font-weight: 600;
    line-height: 1.3;
  }
`;

export const SignupShopPillSpan = styled.span`
  display: inline-flex;
  align-items: center;
  max-width: 220px;
  padding: 6px 10px;
  border-radius: 999px;
  border: 1px solid var(--signup-line);
  background: #f8fafc;
  color: var(--signup-ink);
  font-size: 12px;
  font-weight: 500;
  line-height: 1.3;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const SignupHeadingDiv = styled.div`
  margin-bottom: 24px;

  h1 {
    margin: 0 0 8px;
    color: var(--signup-ink);
    font-size: 26px;
    font-weight: 600;
    letter-spacing: -0.02em;
    line-height: 1.25;
  }

  p {
    margin: 0;
    color: var(--signup-muted);
    font-size: 14px;
    line-height: 1.55;
  }
`;

export const SignupFormDiv = styled.form`
  display: flex;
  flex-direction: column;
  gap: 18px;

  .field {
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  .field label {
    color: var(--signup-ink);
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 0.01em;
  }

  .field .hint {
    color: var(--signup-muted);
    font-size: 11px;
    font-weight: 400;
  }

  .field input[type="text"],
  .field input[type="email"],
  .field input[type="password"] {
    width: 100%;
    height: 42px;
    margin: 0;
    padding: 0 12px;
    border: 1px solid var(--signup-field);
    border-radius: 8px;
    background: #fff;
    color: var(--signup-ink);
    font-size: 14px;
    outline: none;
    transition:
      border-color 0.15s ease,
      box-shadow 0.15s ease;
  }

  .field input:hover {
    border-color: #c5cce3;
  }

  .field input:focus {
    border-color: var(--signup-accent);
    box-shadow: 0 0 0 3px rgba(18, 73, 191, 0.12);
  }

  .row {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 12px;
  }

  @media (max-width: 520px) {
    .row {
      grid-template-columns: 1fr;
    }
  }

  .sectionLabel {
    margin: 4px 0 -4px;
    color: var(--signup-muted);
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.07em;
    text-transform: uppercase;
  }

  .privacy {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    margin-top: 2px;
    color: var(--signup-ink);
    font-size: 13px;
    line-height: 1.45;
    cursor: pointer;
  }

  .privacy input {
    width: 16px;
    height: 16px;
    margin: 2px 0 0;
    accent-color: var(--signup-accent);
    flex-shrink: 0;
  }

  .privacy a {
    color: var(--signup-accent);
    font-weight: 600;
    text-decoration: none;
  }

  .privacy a:hover {
    text-decoration: underline;
  }

  .turnstileSlot {
    min-height: 65px;
  }

  .actions {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-top: 4px;
  }

  .actions .primaryWrap button {
    width: 100%;
  }

  .backLink {
    align-self: center;
    border: none;
    background: transparent;
    color: var(--signup-muted);
    font-size: 13px;
    font-weight: 500;
    cursor: pointer;
    padding: 4px 8px;
  }

  .backLink:hover:not(:disabled) {
    color: var(--signup-accent);
  }

  .backLink:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  .honeypot {
    position: absolute;
    left: -9999px;
    height: 0;
    width: 0;
    opacity: 0;
  }
`;

export const SignupStatusCardDiv = styled(SignupPanelDiv)`
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
  padding: 48px 40px;

  img {
    width: 56px;
    height: 56px;
    object-fit: contain;
  }

  h1 {
    margin: 0;
    color: var(--signup-ink, #262641);
    font-size: 22px;
    font-weight: 600;
    line-height: 1.3;
  }

  p {
    margin: 0;
    max-width: 360px;
    color: var(--signup-muted, #8c8ca1);
    font-size: 14px;
    line-height: 1.55;
  }
`;

export const SuccessPageCardDiv = styled(EmptyStateCardDiv)`
  max-width: 560px;
`;

export const StubPageDiv = styled.div`
  padding: 48px;
  text-align: center;
  color: var(--Light-Grey, #8c8ca1);
  font-size: 14px;
`;
